import { render, staticRenderFns } from "./confirmpass.vue?vue&type=template&id=6dee71e2&"
import script from "./confirmpass.vue?vue&type=script&lang=js&"
export * from "./confirmpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports